<div
    class="{{
        'tw-relative select-home-container tw-w-full tw-bg-white tw-px-[18px] lg:tw-px-[24px] tw-py-[7px] tw-rounded-[16px] ' +
            (errors.length > 0
                ? ' tw-border-2 tw-border-primary-orange '
                : '') +
            (classOverrides !== null ? ' ' + classOverrides : '') +
            (backgroundOverride ? backgroundOverride : '')
    }}"
>
    <div
        class="select-home tw-flex tw-gap-2 tw-items-center tw-text-[12px] tw-leading-[18px] tw-text-caption-gray tw-font-[500]"
    >
        <div class="{{ tooltipDataHeading ? '' : 'tw-w-[316.5px]' }}">
            {{ label | translate }}
            <span class="tw-text-red-400" *ngIf="mandatoryField === true"
                >*</span
            >

            <div
                *ngIf="TooltipData.header !== ''"
                class="tw-relative tw-bottom-[160%] -tw-right-5 md:tw-top-[180%] md:-tw-translate-y-[50%] md:tw-left-32 tw-w-[277px] md:tw-w-[277px]"
            >
                <app-tooltip
                    [showInfoTooltip]="tooltipDataHeading"
                    [tooltipData]="TooltipData"
                ></app-tooltip>
            </div>
        </div>
        <span *ngIf="TooltipData.header == '' && tooltipDataHeading">
            <button
                mat-raised-button
                matTooltip="{{ tooltipDataHeading?.content | translate }}"
                matTooltipPosition="after"
                class="tw-h-full tw-place-items-center"
            >
                <mat-icon
                    class="outlined-icon tw-scale-50 tw-padding-top-[10px]"
                    >info_outline</mat-icon
                >
            </button>
        </span>
    </div>
    <div
        class="wrapper-dropdown tw-w-full tw-flex tw-items-center tw-justify-between"
        id="dropdown"
        (click)="toggleDropdown(!isDropdownOpen)"
    >
        <span
            class="selected-display tw-flex  tw-items-center tw-text-[21px] tw-text-black tw-leading-[32px] tw-font-[500] md:tw-text-[18px] md:tw-leading-[28px] lg:tw-text-[18px] lg:tw-leading-[32px] {{
                getCurrentLabel() ? 'tw-text-black' : 'tw-text-black/[0.24]'
            }}"
        >
            {{
                getCurrentLabel() === undefined
                    ? (placeHolder | translate)
                    : (getCurrentLabel() | translate)
            }}
        </span>
        <div *ngIf="options.length > 1">
            <mat-icon
                aria-label="home icon "
                class="tw-relative"
                [ngClass]="
                    label == ''
                        ? isDropdownOpen
                            ? 'tw-rotate-180 tw-top-1'
                            : 'tw-top-1'
                        : isDropdownOpen
                        ? 'tw-rotate-180 -tw-top-1.5'
                        : '-tw-top-1.5'
                "
            >
                keyboard_arrow_down
            </mat-icon>
        </div>
        <div
            class="dropdown tw-w-[100%] tw-max-h-[350px] tw-overflow-y-auto"
            *ngIf="options.length == 0 ? false : isDropdownOpen"
        >
            <div
                class="tw-relative tw-flex tw-items-center tw-justify-between item tw-w-full tw-py-3 tw-border-b-[1px] tw-px-4 tw-border-b-gray-100"
                *ngFor="let option of options"
                (click)="selectOption($event, option.value)"
            >
                <span class="tw-text-[18px] tw-leading-[32px] tw-font-[500]">{{
                    option.label | translate
                }}</span>
            </div>
        </div>
    </div>
</div>

<div *ngIf="errors.length > 0" class="tw-flex tw-flex-col tw-mt-4">
    <div
        *ngFor="let error of errors; let i = index"
        class="tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
    >
        <mat-icon class="error-icon !tw-overflow-visible"
            >error_outline</mat-icon
        >

        <span
            [ngClass]="{
                'tw-border-b tw-pt-3 tw-pb-3 tw-border-gray-200':
                    i !== errors.length - 1
            }"
            >{{ error }}</span
        >
    </div>
</div>
